import { render, staticRenderFns } from "./AdvertisementConfirmPanel.vue?vue&type=template&id=4a8b74d8&scoped=true"
import script from "./AdvertisementConfirmPanel.vue?vue&type=script&lang=js"
export * from "./AdvertisementConfirmPanel.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementConfirmPanel.vue?vue&type=style&index=0&id=4a8b74d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b74d8",
  null
  
)

export default component.exports